// extracted by mini-css-extract-plugin
module.exports = {"recomendationContainer":"QFrck","svg":"Gfstk","figureWave":"UNvPs","figureGroup":"oxmsA","figureTriangle":"ZjSfX","figureCircle":"pRFd0"};